import { z } from "zod";
import { defaultLang } from "./utils.js";
const literalCondition = (value, error, empty)=>('string' == typeof value && '' !== value ? z.literal(value, error ? {
        error
    } : void 0) : void 0) ?? (value ? z.any() : z.undefined(empty ? {
        error: empty
    } : void 0));
const checkDetail = (detail, { async, schema })=>{
    if (schema) {
        const result = async ? schema.safeParseAsync(detail) : Promise.resolve(schema.safeParse(detail));
        return result.then((cause)=>cause.success ? cause : Promise.reject(new Error(cause.error.issues.slice(-1)[0].message, {
                cause
            })));
    }
    return Promise.reject(new Error('schema required'));
};
const checkLiteral = (data, { group, lang, token, filter }, currentToken)=>{
    const { customError, groupEmpty, groupProvider, tokenEmpty, tokenProvider } = {
        ...defaultLang,
        ...lang
    };
    const schema = z.object({
        group: literalCondition(group ?? data.global, groupProvider, groupEmpty),
        token: literalCondition(token ? currentToken : data.global, tokenProvider, tokenEmpty)
    });
    const result = filter ? schema.refine(async ()=>{
        const detailRecord = {
            ...data
        };
        Reflect.deleteProperty(detailRecord, 'detail');
        const verify = await Promise.resolve(detailRecord).then(filter).catch(()=>false);
        return verify;
    }, {
        error: customError
    }).safeParseAsync(data) : Promise.resolve(schema.safeParse(data));
    return result.then((cause)=>{
        if (!cause.success) return Promise.reject(new Error('', {
            cause
        }));
        const resultData = {
            ...data,
            token: currentToken,
            group
        };
        return resultData;
    });
};
const validate = (data, record, currentToken)=>checkLiteral(data, record, currentToken).then((detail)=>checkDetail(data.detail, record).then((result)=>({
                ...detail,
                detail: result.data
            })));
export { checkDetail, checkLiteral, validate };
